import { Component } from '@angular/core';
import { NormalReportService, NormalReportInput,TeamNormalReportInput } from './../../services/normalreport.service';
import { LoaddingService } from './../../providers/loadding.service';
import { NormalReportModel } from './../../models/normalreport.model';
import { AppConfig } from './../../app/app.config';
import { ModalController } from 'ionic-angular';
import { NormalSearch } from './normalsearch';
import { ContinuePage } from './continue';
import { ContinueBettingPage } from './continue-betting';
 

/*
    游戏记录
    TQQ 2016-12-28
*/
@Component({
    selector: "normal-report",
    templateUrl: "normalreport.html",
    providers: [NormalReportService]
})
export class NormalReport {
    constructor(
        private normalreport: NormalReportService,
        private loadding: LoaddingService,
        private modalCtrl: ModalController,
        private config:AppConfig) { }

    modelList: NormalReportModel[];
    isHave = true;
    paras = new NormalReportInput();
    para=new TeamNormalReportInput();
    username = this.config.getCurrentUser().UserName;
    hasmore = false;
    teamFlag:boolean=false;

    excludeTracks = [];

    ionViewDidLoad() {
        let load = this.loadding.showLoding();
        this.paras.UserName=this.username;
        this.getNormalReport(this.paras).then(() => {
            this.loadding.closeLoading(load);
        });
    }
    // 续投
    continue(report){
        // let modal = this.modalCtrl.create(ContinuePage,{report});
        let modal = this.modalCtrl.create(ContinueBettingPage,{report});
        modal.present();
        modal.onWillDismiss((data: any[]) => {
            this.getNormalReport(this.paras);
        })
    }

    //下拉重新加载
    //TQQ 2016-12-29
    doRefresh(refresher) {
        this.paras.PageIndex = 1;
        this.para.pageIndex = 1;
        if(!this.teamFlag){
            this.getNormalReport(this.paras).then(() => {
                refresher.complete();
            });
        }else{
             this.getTeamNormalReport(this.para).then(() => {
                refresher.complete();
            });
        }

    }


    //上拉获取下一页信息
    //TQQ 2016-12-29
    doInfinite(infiniteScroll) {
        if(!this.teamFlag){
            this.paras.PageIndex++;          
            this.getNormalReport(this.paras).then(() => {
               infiniteScroll.complete();
            });
        }else{
            this.para.pageIndex++;              
            this.getTeamNormalReport(this.para).then(() => {
                infiniteScroll.complete();
            });
        }
    }

    //查询条件
    //TQQ 2016-12-30
    presentFilter() {
        let modal = this.modalCtrl.create(NormalSearch, this.excludeTracks);
        modal.present();
        modal.onWillDismiss((data: any[]) => {
            if (data) {
                this.excludeTracks = data;
                if(this.excludeTracks["Type"]=='1'){
                    this.teamFlag=true;
                    this.para.start = this.excludeTracks["startDate"];
                    this.para.end = this.excludeTracks["endDate"];
                    this.para.lotteryCode = this.excludeTracks["lotteryCode"];
                    this.para.userName=this.excludeTracks["subUserName"];
                    this.getTeamNormalReport(this.para);
                }else{    
                    this.teamFlag=false;                    
                    this.paras.StartDate = this.excludeTracks["startDate"];
                    this.paras.EndDate = this.excludeTracks["endDate"];
                    this.paras.LotteryCode = this.excludeTracks["lotteryCode"];
                    this.paras.IssueNo = this.excludeTracks["issueNo"];
                    this.paras.State = this.excludeTracks["state"];
                    this.paras.UserName=this.username;
                    this.getNormalReport(this.paras);
                }
            }
        });

    }


    //获取常规投注信息
    //TQQ 2016-12-30
    getNormalReport(input: NormalReportInput) {
        return this.normalreport.getNormalReport(input).then(s => {
            if (s.List != null) {
                if (input.PageIndex == 1) {
                    this.modelList = [];
                    this.modelList = s.List;
                    if (s.List.length < s.PageCount) {
                        this.hasmore = true;
                    } else {
                        this.hasmore = false;
                    }
                } else {
                    this.modelList = this.modelList.concat(s.List);
                    if (this.modelList.length < s.PageCount) {
                        this.hasmore = true;
                    }
                    else {
                        input.PageIndex = 1;
                        this.hasmore = false;
                    }
                }
            } else {
                this.modelList = [];
            }
            if (this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        });
    }
    //获取团队游戏记录
    getTeamNormalReport(input:TeamNormalReportInput) {
       return this.normalreport.getTeamNormalReport(input).then(s => {
            if (s.List != null) {
                if (input.pageIndex == 1) {
                    this.modelList = [];
                    this.modelList = s.List;
                    if (s.List.length < s.PageCount) {
                        this.hasmore = true;
                    } else {
                        this.hasmore = false;
                    }
                } else {
                    this.modelList = this.modelList.concat(s.List);
                    if (this.modelList.length < s.PageCount) {
                        this.hasmore = true;
                    }
                    else {
                        input.pageIndex = 1;
                        this.hasmore = false;
                    }
                }
            } else {
                this.modelList = [];
            }
            if (this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        });
    }

    //撤单回调
    //TQQ 2017-02-22
    callback = () => {
        this.getNormalReport(this.paras);
    };



}




// WEBPACK FOOTER //
// ./src/pages/normalreport/normalreport.ts